import apiClient from "../../../utilities/apiClient";

export const addSubCategory = (payload) => {
  return apiClient.post(`${apiClient.Urls.sub_category}`, payload, true);
};

export const getSubCategories = (page, per_page, search) => {
  return apiClient.get(
    `${apiClient.Urls.sub_category}?page=${page}&per_page=${per_page}&search=${
      search || ""
    }`,
    "",
    true
  );
};

export const updateSubCategory = (id, payload) => {
  return apiClient.put(`${apiClient.Urls.sub_category}/${id}`, payload, true);
};

export const deleteSubCategory = (id) => {
  return apiClient.delete(`${apiClient.Urls.sub_category}/${id}`, {}, true);
};
